import { lazy } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';

const Packages = lazy(() => import('../../container/packages/Packages'));
const AddPackage = lazy(() => import('../../container/packages/overview/AddPackage'));
const PaymentSuccess = lazy(() => import('../../container/payment/PaymentSuccess'));
const PaymentFailed = lazy(() => import('../../container/payment/PaymentFailed'));
const EditPackage = lazy(() => import('../../container/packages/overview/EditPackage'));

function BillingRoutes() {
  const { path } = useRouteMatch();
  const isAdmin = useSelector((state) => state.auth.login.user?.role === 'Admin');

  return (
    <Switch>
      <Route path={`${path}/packages`} component={Packages} />
      <Route path={`${path}/add-package`} component={AddPackage} />
      <Route
        path={`${path}/edit/:id`}
        render={() => (isAdmin ? <EditPackage /> : <Redirect to={`${path}/packages`} />)}
      />
      <Route path={`${path}/payment/success`} component={PaymentSuccess} />
      <Route path={`${path}/payment/failed`} component={PaymentFailed} />
    </Switch>
  );
}

export default BillingRoutes;
